import './loader.css';
export const Loader = (props: { label: string }) => {
    const { label } = props;
    return (
        <div className="wrapper">
            <div className="circle-wrapper">
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle-shadow"></div>
                <div className="circle-shadow"></div>
                <div className="circle-shadow"></div>
            </div>
            <span>{label}</span>
        </div>
    );
};
